import { TOptionsState, TRootState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { optionsAdapter } from './adapter'

const selectState = (state: TRootState): TOptionsState => state.options

const adapterSelectors = optionsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)


export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}